import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import api from '../services/api';
import { useToast } from '../hooks/useToast';

const إدارةالمدفوعات = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [statistics, setStatistics] = useState(null);
  const [loadingStats, setLoadingStats] = useState(false);
  const { showToast, ToastContainer } = useToast();

  // Filters
  const [filters, setFilters] = useState({
    paymentStatus: '',
    restaurantId: '',
    userId: '',
    fromDate: '',
    toDate: '',
    search: '',
  });

  useEffect(() => {
    fetchTransactions();
    fetchStatistics();
  }, [page, filters]);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const response = await api.getPaymentTransactions({
        page: page.toString(),
        limit: '20',
        ...filters
      });
      
      if (response && response.items) {
        setTransactions(response.items);
        setTotalPages(response.totalPages || 1);
        setTotal(response.total || 0);
      }
    } catch (error) {
      console.error('Error fetching transactions:', error);
      showToast('حدث خطأ في جلب المعاملات', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchStatistics = async () => {
    try {
      setLoadingStats(true);
      const response = await api.getPaymentStatistics({
        fromDate: filters.fromDate || undefined,
        toDate: filters.toDate || undefined,
        restaurantId: filters.restaurantId || undefined,
      });
      setStatistics(response);
    } catch (error) {
      console.error('Error fetching statistics:', error);
    } finally {
      setLoadingStats(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
    setPage(1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('ar-SA', {
      style: 'currency',
      currency: 'SAR'
    }).format(price || 0);
  };

  const getPaymentStatusColor = (status) => {
    const colors = {
      PENDING: '#FFA500',
      AUTHORIZED: '#4A90E2',
      PAID: '#3FB984',
      FAILED: '#E96A3A',
      REFUNDED: '#666A7A',
    };
    return colors[status] || '#666A7A';
  };

  const getPaymentStatusLabel = (status) => {
    const labels = {
      PENDING: 'قيد الدفع',
      AUTHORIZED: 'مصرح',
      PAID: 'مدفوع',
      FAILED: 'فشل',
      REFUNDED: 'مسترد',
    };
    return labels[status] || status;
  };

  return (
    <div style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#2B2F3F',
      overflow: 'hidden',
      direction: 'rtl'
    }}>
      <Header />
      <div style={{ 
        flex: 1, 
        padding: '32px', 
        backgroundColor: '#2B2F3F', 
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        boxSizing: 'border-box'
      }}>
        {/* Page Title */}
        <h1 style={{
          fontFamily: 'El Messiri, sans-serif',
          fontSize: '24px',
          fontWeight: 700,
          color: '#FFFFFF',
          margin: '0 0 8px 0',
          textAlign: 'right'
        }}>
          إدارة المدفوعات
        </h1>

        {/* Statistics Cards */}
        {statistics && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '16px',
            marginBottom: '16px'
          }}>
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: '20px',
              border: '1px solid rgba(233, 106, 58, 0.15)',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)'
            }}>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '12px',
                color: '#666A7A',
                marginBottom: '8px'
              }}>
                إجمالي الإيرادات
              </div>
              <div style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '24px',
                fontWeight: 700,
                color: '#3FB984'
              }}>
                {formatPrice(statistics.totalRevenue)}
              </div>
            </div>
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: '20px',
              border: '1px solid rgba(233, 106, 58, 0.15)',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)'
            }}>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '12px',
                color: '#666A7A',
                marginBottom: '8px'
              }}>
                إجمالي المعاملات
              </div>
              <div style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '24px',
                fontWeight: 700,
                color: '#2B2F3F'
              }}>
                {statistics.totalTransactions?.toLocaleString('ar-SA') || 0}
              </div>
            </div>
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: '20px',
              border: '1px solid rgba(233, 106, 58, 0.15)',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)'
            }}>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '12px',
                color: '#666A7A',
                marginBottom: '8px'
              }}>
                المدفوعات المعلقة
              </div>
              <div style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '24px',
                fontWeight: 700,
                color: '#FFA500'
              }}>
                {formatPrice(statistics.pendingAmount)}
              </div>
            </div>
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: '20px',
              border: '1px solid rgba(233, 106, 58, 0.15)',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)'
            }}>
              <div style={{
                fontFamily: 'Cairo, sans-serif',
                fontSize: '12px',
                color: '#666A7A',
                marginBottom: '8px'
              }}>
                إيرادات اليوم
              </div>
              <div style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '24px',
                fontWeight: 700,
                color: '#2B2F3F'
              }}>
                {formatPrice(statistics.todayRevenue)}
              </div>
            </div>
          </div>
        )}

        {/* Filters */}
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          padding: '24px',
          border: '1px solid rgba(233, 106, 58, 0.15)',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '16px'
          }}>
            <input
              type="text"
              placeholder="بحث (PayPal ID، مطعم، عميل)"
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
              style={{
                padding: '10px 16px',
                borderRadius: '12px',
                border: '1px solid rgba(102, 106, 122, 0.22)',
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
              dir="rtl"
            />
            <select
              value={filters.paymentStatus}
              onChange={(e) => handleFilterChange('paymentStatus', e.target.value)}
              style={{
                padding: '10px 16px',
                borderRadius: '12px',
                border: '1px solid rgba(102, 106, 122, 0.22)',
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box',
                cursor: 'pointer'
              }}
              dir="rtl"
            >
              <option value="">جميع حالات الدفع</option>
              <option value="PENDING">قيد الدفع</option>
              <option value="AUTHORIZED">مصرح</option>
              <option value="PAID">مدفوع</option>
              <option value="FAILED">فشل</option>
              <option value="REFUNDED">مسترد</option>
            </select>
            <input
              type="date"
              placeholder="من تاريخ"
              value={filters.fromDate}
              onChange={(e) => handleFilterChange('fromDate', e.target.value)}
              style={{
                padding: '10px 16px',
                borderRadius: '12px',
                border: '1px solid rgba(102, 106, 122, 0.22)',
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
            <input
              type="date"
              placeholder="إلى تاريخ"
              value={filters.toDate}
              onChange={(e) => handleFilterChange('toDate', e.target.value)}
              style={{
                padding: '10px 16px',
                borderRadius: '12px',
                border: '1px solid rgba(102, 106, 122, 0.22)',
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
            <button
              onClick={() => {
                setFilters({
                  paymentStatus: '',
                  restaurantId: '',
                  userId: '',
                  fromDate: '',
                  toDate: '',
                  search: '',
                });
                setPage(1);
              }}
              style={{
                padding: '10px 20px',
                borderRadius: '12px',
                border: '1px solid rgba(102, 106, 122, 0.22)',
                backgroundColor: '#FFFFFF',
                color: '#666A7A',
                fontFamily: 'Cairo, sans-serif',
                fontSize: '14px',
                cursor: 'pointer',
                boxSizing: 'border-box'
              }}
            >
              إعادة تعيين
            </button>
          </div>
        </div>

        {/* Transactions Table */}
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          padding: '24px',
          border: '1px solid rgba(233, 106, 58, 0.15)',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
          flex: 1,
          overflow: 'auto',
          boxSizing: 'border-box'
        }}>
          {loading ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '40px',
              color: '#666A7A',
              fontFamily: 'Cairo, sans-serif'
            }}>
              جاري التحميل...
            </div>
          ) : transactions.length === 0 ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '40px',
              color: '#666A7A',
              fontFamily: 'Cairo, sans-serif'
            }}>
              لا توجد معاملات
            </div>
          ) : (
            <>
              <div style={{ overflowX: 'auto' }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontFamily: 'Cairo, sans-serif'
                }}>
                  <thead>
                    <tr style={{
                      borderBottom: '2px solid #E5E7EB'
                    }}>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>رقم المعاملة</th>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>العميل</th>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>المطعم</th>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>المبلغ</th>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>حالة الدفع</th>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>طريقة الدفع</th>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>PayPal ID</th>
                      <th style={{
                        padding: '12px',
                        textAlign: 'right',
                        fontFamily: 'El Messiri, sans-serif',
                        fontSize: '14px',
                        fontWeight: 700,
                        color: '#2B2F3F'
                      }}>التاريخ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((transaction) => (
                      <tr key={transaction.id} style={{
                        borderBottom: '1px solid #E5E7EB'
                      }}>
                        <td style={{
                          padding: '12px',
                          fontSize: '14px',
                          color: '#2B2F3F'
                        }}>#{transaction.orderId?.substring(0, 8) || transaction.id.substring(0, 8)}</td>
                        <td style={{
                          padding: '12px',
                          fontSize: '14px',
                          color: '#2B2F3F'
                        }}>
                          {transaction.user ? `${transaction.user.firstName} ${transaction.user.lastName}` : '-'}
                        </td>
                        <td style={{
                          padding: '12px',
                          fontSize: '14px',
                          color: '#2B2F3F'
                        }}>
                          {transaction.restaurant?.name || '-'}
                        </td>
                        <td style={{
                          padding: '12px',
                          fontSize: '14px',
                          color: '#2B2F3F',
                          fontWeight: 600
                        }}>
                          {formatPrice(transaction.amount)}
                        </td>
                        <td style={{
                          padding: '12px',
                          fontSize: '14px'
                        }}>
                          <span style={{
                            padding: '4px 12px',
                            borderRadius: '8px',
                            backgroundColor: getPaymentStatusColor(transaction.paymentStatus) + '20',
                            color: getPaymentStatusColor(transaction.paymentStatus),
                            fontFamily: 'Cairo, sans-serif',
                            fontSize: '12px',
                            fontWeight: 600
                          }}>
                            {getPaymentStatusLabel(transaction.paymentStatus)}
                          </span>
                        </td>
                        <td style={{
                          padding: '12px',
                          fontSize: '14px',
                          color: '#666A7A'
                        }}>
                          {transaction.paymentMethod || '-'}
                        </td>
                        <td style={{
                          padding: '12px',
                          fontSize: '12px',
                          color: '#666A7A',
                          fontFamily: 'monospace'
                        }}>
                          {transaction.paypalOrderId ? transaction.paypalOrderId.substring(0, 15) + '...' : '-'}
                        </td>
                        <td style={{
                          padding: '12px',
                          fontSize: '14px',
                          color: '#666A7A'
                        }}>
                          {formatDate(transaction.createdAt)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '24px',
                  paddingTop: '24px',
                  borderTop: '1px solid #E5E7EB',
                  flexWrap: 'wrap',
                  gap: '12px'
                }}>
                  <div style={{
                    fontFamily: 'Cairo, sans-serif',
                    fontSize: '13px',
                    color: '#666A7A'
                  }}>
                    عرض {transactions.length} من {total} معاملة
                  </div>
                  <div style={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center'
                  }}>
                    <button
                      onClick={() => setPage(1)}
                      disabled={page === 1}
                      style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: '1px solid rgba(102, 106, 122, 0.22)',
                        backgroundColor: page === 1 ? '#f5f5f5' : '#FFFFFF',
                        color: page === 1 ? '#999' : '#666A7A',
                        fontFamily: 'Cairo, sans-serif',
                        fontSize: '13px',
                        cursor: page === 1 ? 'not-allowed' : 'pointer',
                        opacity: page === 1 ? 0.6 : 1
                      }}
                    >
                      الأولى
                    </button>
                    <button
                      onClick={() => setPage(prev => Math.max(1, prev - 1))}
                      disabled={page === 1}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: '1px solid rgba(102, 106, 122, 0.22)',
                        backgroundColor: page === 1 ? '#f5f5f5' : '#FFFFFF',
                        color: page === 1 ? '#999' : '#666A7A',
                        fontFamily: 'Cairo, sans-serif',
                        fontSize: '14px',
                        cursor: page === 1 ? 'not-allowed' : 'pointer',
                        opacity: page === 1 ? 0.6 : 1
                      }}
                    >
                      السابق
                    </button>
                    <div style={{
                      display: 'flex',
                      gap: '4px',
                      alignItems: 'center',
                      padding: '0 8px'
                    }}>
                      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                        let pageNum;
                        if (totalPages <= 5) {
                          pageNum = i + 1;
                        } else if (page <= 3) {
                          pageNum = i + 1;
                        } else if (page >= totalPages - 2) {
                          pageNum = totalPages - 4 + i;
                        } else {
                          pageNum = page - 2 + i;
                        }
                        
                        return (
                          <button
                            key={pageNum}
                            onClick={() => setPage(pageNum)}
                            style={{
                              padding: '8px 12px',
                              borderRadius: '6px',
                              border: 'none',
                              backgroundColor: page === pageNum ? '#E96A3A' : 'transparent',
                              color: page === pageNum ? '#FFFFFF' : '#666A7A',
                              fontFamily: 'Cairo, sans-serif',
                              fontSize: '14px',
                              fontWeight: page === pageNum ? 600 : 400,
                              cursor: 'pointer',
                              minWidth: '36px'
                            }}
                          >
                            {pageNum}
                          </button>
                        );
                      })}
                    </div>
                    <button
                      onClick={() => setPage(prev => Math.min(totalPages, prev + 1))}
                      disabled={page === totalPages}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        border: '1px solid rgba(102, 106, 122, 0.22)',
                        backgroundColor: page === totalPages ? '#f5f5f5' : '#FFFFFF',
                        color: page === totalPages ? '#999' : '#666A7A',
                        fontFamily: 'Cairo, sans-serif',
                        fontSize: '14px',
                        cursor: page === totalPages ? 'not-allowed' : 'pointer',
                        opacity: page === totalPages ? 0.6 : 1
                      }}
                    >
                      التالي
                    </button>
                    <button
                      onClick={() => setPage(totalPages)}
                      disabled={page === totalPages}
                      style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: '1px solid rgba(102, 106, 122, 0.22)',
                        backgroundColor: page === totalPages ? '#f5f5f5' : '#FFFFFF',
                        color: page === totalPages ? '#999' : '#666A7A',
                        fontFamily: 'Cairo, sans-serif',
                        fontSize: '13px',
                        cursor: page === totalPages ? 'not-allowed' : 'pointer',
                        opacity: page === totalPages ? 0.6 : 1
                      }}
                    >
                      الأخيرة
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default إدارةالمدفوعات;















